import {
  faListCheck,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useLayoutEffect, useState } from "react";
import RPModal from "../../Modal/RPModal";
import { AXIOS_GET } from "../../server/api/crud";
import VoedingForm from "./voeding/VoedingForm";

function VoedingDagboek({ swipperRef, userdetails,  user, navigation }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
  });

  useLayoutEffect(() => {
    const fetchData = async (p_id) => {
      try {
        const response = await AXIOS_GET(`voedsel/${p_id}`);
        if (response.data.data[0]) setFormData(response.data.data[0]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (user) {
      const { id } = user;
      fetchData(id);
      //Redirect to home page if user is already logged in
    }
  }, [open
  ]);
  const cardClass =
    "group relative mx-auto flex w-full max-w-2xl flex-col items-center gap-5 rounded-2xl border border-dashed border-wa-border bg-wa-panel2/35 p-10 text-center shadow-[0_20px_60px_-36px_rgba(0,0,0,0.45)] backdrop-blur-sm transition-colors hover:border-wa-accent/45 hover:bg-wa-panel2/55 focus:outline-none focus-visible:ring-2 focus-visible:ring-wa-accent/35 focus-visible:ring-offset-2 focus-visible:ring-offset-wa-app sm:p-12";

  return (
    <div className="mt-10 flex justify-center px-3 sm:mt-14 sm:px-4">
      {formData.status == "current" ? (
        <button type="button" onClick={() => setOpen(true)} className={cardClass}>
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-wa-accent/15 text-3xl text-wa-accent ring-1 ring-wa-accent/25">
            <FontAwesomeIcon icon={faListCheck} />
          </div>
          <span className="block max-w-lg text-base font-semibold leading-relaxed text-wa-text sm:text-lg">
            Het voedingsformulier is al ingevuld. Wilt u nog aanpassingen maken?
            Klik op deze ruimte.
          </span>
        </button>
      ) : formData.status == "completed" ? (
        <button type="button" onClick={() => setOpen(true)} className={cardClass}>
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-wa-accent/15 text-3xl text-wa-accent ring-1 ring-wa-accent/25">
            <FontAwesomeIcon icon={faPaperPlane} />
          </div>
          <span className="block max-w-lg text-base font-semibold leading-relaxed text-wa-text sm:text-lg">
            Het voedingsformulier is ingevuld en verstuurd. Wenst u nog
            aanpassingen te maken? Stuur dan een e-mail via de mailbox naar de
            arts.
          </span>
        </button>
      ) : (
        <button type="button" onClick={() => setOpen(true)} className={cardClass}>
          <svg
            className="h-14 w-14 shrink-0 text-wa-muted transition-colors group-hover:text-wa-accent"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 48 48"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 2H32C33.1 2 34 2.9 34 4V44C34 45.1 33.1 46 32 46H12C10.9 46 10 45.1 10 44V4C10 2.9 10.9 2 12 2Z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M10 2H24L34 12H10V2Z"
            />
          </svg>
          <span className="block max-w-md text-base font-semibold leading-relaxed text-wa-text sm:text-lg">
            Vul uw voedingsformulier in door op deze ruimte te klikken.
          </span>
        </button>
      )}
      <RPModal
        setOpen={setOpen}
        forms={formData}
        open={open}
        title={"Pre-intake"}
        Component={
          <VoedingForm
            userdetails={userdetails}
            setOpen={setOpen}
            formData={formData}
            setFormData={setFormData}
          />
        }
      />
    </div>
  );
}

export default VoedingDagboek;
